/**
 * Los importes de una línea de factura, tal como están guardados.
 *
 * Vive suelto y sin importar nada, como `coincidencia.js`: estaba dentro de
 * `DialogoRectificativa.jsx`, que importa `@/App` para el axios configurado,
 * así que probar seis líneas de aritmética arrastraba la aplicación entera.
 */

/**
 * Devuelve { base, cuota } de una línea SIN recalcular nada.
 *
 * No se hace cantidad × precio a propósito. Hay 30 facturas cuyo descuento
 * está metido dentro del importe con el campo `discount` a 0 -- 39,90 guardado
 * como 31,92, que es un 20% -- y recalcularlas enseñaría, y abonaría, de más.
 *
 * Es la misma regla que aplica el servidor en `_importe_linea`. Tienen que
 * coincidir: si la pantalla dijera una cifra y el abono saliera por otra,
 * nadie volvería a fiarse de la pantalla.
 */
export function importeDeLinea(linea) {
  const num = (v) => (v === null || v === undefined || v === '' ? null : Number(v));
  const base = num(linea?.subtotal) ?? 0;

  let cuota = num(linea?.iva_amount);
  if (cuota === null) cuota = num(linea?.tax);
  if (cuota === null) {
    const tipo = num(linea?.tax_rate);
    cuota = tipo === null ? 0 : Math.round(base * tipo) / 100;
  }
  return { base, cuota };
}

export default importeDeLinea;
